import { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './styles.css'

const updateEvent = 'coach-board-update-ready'
let updateReady = false

const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateReady = true
    window.dispatchEvent(new Event(updateEvent))
  },
  onRegisteredSW(_url, registration) {
    if (!registration) return
    const checkForUpdate = () => {
      if (document.visibilityState !== 'visible' || !navigator.onLine) return
      void registration.update().catch(() => {})
    }
    checkForUpdate()
    const interval = window.setInterval(checkForUpdate, 60 * 60 * 1000)
    window.addEventListener('focus', checkForUpdate)
    window.addEventListener('online', checkForUpdate)
    document.addEventListener('visibilitychange', checkForUpdate)
    window.addEventListener('pagehide', () => window.clearInterval(interval), { once: true })
  },
})

function PwaUpdatePrompt() {
  const [visible, setVisible] = useState(updateReady)
  useEffect(() => {
    const show = () => setVisible(true)
    window.addEventListener(updateEvent, show)
    return () => window.removeEventListener(updateEvent, show)
  }, [])
  if (!visible) return null
  return <div className="pwa-update" role="status"><span>A Coach Board update is available.</span><button onClick={() => void updateServiceWorker(true)}>Reload to update</button></div>
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <PwaUpdatePrompt />
  </StrictMode>,
)
